import * as amplitude from "@amplitude/analytics-browser";
import axios from "axios";
import qs from "query-string";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import SpinnerLoading from "../../components/Loading/SpinnerLoader";
import { getBackendUrl } from "../../utils";
import BankFeedsCommonLayout from "../../components/bankFeeds/layout";

const PlaidBankFeedsRedirect: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const history = useHistory();
  const { search } = history.location;
  const parsedSearch: any = qs.parse(search);
  const { challenge, otp } = parsedSearch;

  useEffect(() => {
    amplitude.track("Plaid Bank Feeds: Oauth Redirect");

    axios
      .post(
        `${getBackendUrl()}/plaid_bank_feeds_connector/auth/login?rutter_challenge=${challenge}&otp=${otp}`,
      )
      .then((response) => {
        amplitude.track(
          "Plaid Bank Feeds: Oauth OTP Success, redirecting to Ory",
        );

        window.location.replace(response.data);
      })
      .catch((err) => {
        amplitude.track("Plaid Bank Feeds: Oauth OTP Error");
        setErrorMessage(
          err.response?.data?.error_message ?? "Something went wrong.",
        );
        setIsLoading(false);
      });
  }, [challenge, otp]);

  return isLoading ? (
    <div className="flex justify-center items-center h-screen">
      <SpinnerLoading size={60} />
    </div>
  ) : (
    <BankFeedsCommonLayout errorMessage={errorMessage}>
      <div className="w-full text-center">
        <span className="text-red-500">
          Please retry the auth process from the beginning.
        </span>
      </div>
    </BankFeedsCommonLayout>
  );
};

export default PlaidBankFeedsRedirect;
